export default __webpack_public_path__ + "static/media/back3.63d7a327.jpg";